'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $p_Ljava_math_Conversion$__dropLeadingZeros__T__T($thiz, s) {
  var zeroPrefixLength = 0;
  var len = s.length;
  while (((zeroPrefixLength < len) && (s.charCodeAt(zeroPrefixLength) === 48))) {
    zeroPrefixLength = ((1 + zeroPrefixLength) | 0);
  }
  var beginIndex = zeroPrefixLength;
  return s.substring(beginIndex);
}
export { $p_Ljava_math_Conversion$__dropLeadingZeros__T__T as $p_Ljava_math_Conversion$__dropLeadingZeros__T__T };
/** @constructor */
function $c_Ljava_math_Conversion$() {
  this.IS = null;
  this.IR = null;
  $n_Ljava_math_Conversion$ = this;
  this.IS = $j_java$002elang$002e$002dObject.$constArrSDiffs_I(37, "|]1]qy{{]||]|]]]|]]]]]]|]]]]]]]]]]]]]|");
  this.IR = $j_java$002elang$002e$002dObject.$constArrRaw_I(35, "44444jyh:M84444HMFcl@54rWNmaTjUU44444aL`OT54BguFYiimD444YbI@HxAD48hyOyr:kd444448mMLUP4@kyInVbULE44pJDqYSRi:HB@h5m`ip@444`iHLBqd74uRRJ`L`OT54H`C;QZ8U[48foiJHwPFE444449DGvo8HPG5OQLS`i54eRF44");
}
export { $c_Ljava_math_Conversion$ as $c_Ljava_math_Conversion$ };
$p = $c_Ljava_math_Conversion$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_math_Conversion$;
/** @constructor */
function $h_Ljava_math_Conversion$() {
}
export { $h_Ljava_math_Conversion$ as $h_Ljava_math_Conversion$ };
$h_Ljava_math_Conversion$.prototype = $p;
$p.rp = (function(bi) {
  var sign = bi.a3;
  var numberLength = bi.a8;
  var digits = bi.Y;
  if ((sign === 0)) {
    return "0";
  } else if ((numberLength === 1)) {
    var i = digits.a[0];
    var absStr = (i >>> 0.0).toString(10);
    return ((sign < 0) ? ("-" + absStr) : absStr);
  } else {
    var result = "";
    var temp = new $j_java$002elang$002e$002dObject.$ac_I(numberLength);
    var tempLen = numberLength;
    var x4 = tempLen;
    digits.K(0, temp, 0, x4);
    while (true) {
      var rem = 0;
      var i$1 = ((tempLen - 1) | 0);
      while ((i$1 >= 0)) {
        var value = rem;
        var value$1 = temp.a[i$1];
        var aHat = ((4.294967296E9 * (value >>> 0.0)) + (value$1 >>> 0.0));
        var x = (1.0000000000000017E-9 * aHat);
        var lo = (x | 0.0);
        var hi$2 = ((2.3283064365386963E-10 * x) | 0.0);
        var rHat = ((value$1 - Math.imul(1000000000, lo)) | 0);
        if ((rHat < 0)) {
          var lo$1 = ((lo - 1) | 0);
          var hi$3 = ((((hi$2 - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
          var x$2_$_lo = lo$1;
          var x$2_$_hi = hi$3;
        } else {
          var x$2_$_lo = lo;
          var x$2_$_hi = hi$2;
        }
        temp.a[i$1] = x$2_$_lo;
        var b0 = (65535 & x$2_$_lo);
        rem = ((value$1 - ((Math.imul(51712, b0) + (((Math.imul(15258, b0) + Math.imul(51712, ((x$2_$_lo >>> 16) | 0))) | 0) << 16)) | 0)) | 0);
        i$1 = ((i$1 - 1) | 0);
      }
      var this$22 = rem;
      var remStr = ("" + this$22);
      var beginIndex = remStr.length;
      var padding = "000000000".substring(beginIndex);
      result = ((padding + remStr) + result);
      while (((tempLen !== 0) && (temp.a[((tempLen - 1) | 0)] === 0))) {
        tempLen = ((tempLen - 1) | 0);
      }
      if ((tempLen !== 0)) {
      } else {
        break;
      }
    }
    result = $p_Ljava_math_Conversion$__dropLeadingZeros__T__T(this, result);
    return ((sign < 0) ? ("-" + result) : result);
  }
});
$p.Y6 = (function(value_$_lo, value_$_hi, scale) {
  if (((value_$_lo | value_$_hi) === 0)) {
    switch (scale) {
      case 0: {
        return "0";
        break;
      }
      case 1: {
        return "0.0";
        break;
      }
      case 2: {
        return "0.00";
        break;
      }
      case 3: {
        return "0.000";
        break;
      }
      case 4: {
        return "0.0000";
        break;
      }
      case 5: {
        return "0.00000";
        break;
      }
      case 6: {
        return "0.000000";
        break;
      }
      default: {
        var scaleVal = ((scale === (-2147483648)) ? "2147483648" : ("" + ((-scale) | 0)));
        return (((scale < 0) ? "0E+" : "0E") + scaleVal);
      }
    }
  } else {
    var negNumber = (value_$_hi < 0);
    var elem = null;
    elem = "";
    var currentChar = 18;
    if (negNumber) {
      var lo = ((-value_$_lo) | 0);
      var hi = ((((-value_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      var v_$_lo = lo;
      var v_$_hi = hi;
    } else {
      var v_$_lo = value_$_lo;
      var v_$_hi = value_$_hi;
    }
    while (true) {
      var prev_$_lo = v_$_lo;
      var prev_$_hi = v_$_hi;
      var num_$_lo = v_$_lo;
      var num_$_hi = v_$_hi;
      var sign = (num_$_hi >> 31);
      var xlo = (num_$_lo ^ sign);
      var rlo = ((xlo - sign) | 0);
      var rhi = (((num_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
      var quotHi = (((rhi >>> 0) / 10) | 0);
      var k = ((rhi - Math.imul(10, quotHi)) | 0);
      var quotLo = ((0.10000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
      if ((num_$_hi < 0)) {
        var lo$1 = ((-quotLo) | 0);
        var hi$1 = ((((-quotHi) | 0) - ((lo$1 !== 0) | 0)) | 0);
        v_$_lo = lo$1;
        v_$_hi = hi$1;
      } else {
        v_$_lo = quotLo;
        v_$_hi = quotHi;
      }
      currentChar = ((currentChar - 1) | 0);
      var x$1_$_lo = v_$_lo;
      var x$1_$_hi = v_$_hi;
      elem = (("" + ((prev_$_lo - ((Math.imul(10, (65535 & x$1_$_lo)) + (Math.imul(10, ((x$1_$_lo >>> 16) | 0)) << 16)) | 0)) | 0)) + elem);
      var x$2_$_lo = v_$_lo;
      var x$2_$_hi = v_$_hi;
      if (((x$2_$_lo | x$2_$_hi) !== 0)) {
      } else {
        break;
      }
    }
    var value$1 = ((18 - currentChar) | 0);
    var hi$4 = (value$1 >> 31);
    var hi$5 = (scale >> 31);
    var lo$4 = ((value$1 - scale) | 0);
    var hi$6 = ((((hi$4 - hi$5) | 0) - (((lo$4 >>> 0) > (value$1 >>> 0)) | 0)) | 0);
    var lo$5 = ((lo$4 - 1) | 0);
    var hi$7 = ((((hi$6 - 1) | 0) + ((lo$5 !== (-1)) | 0)) | 0);
    if (((scale > 0) && ((hi$7 === (-1)) ? ((lo$5 >>> 0) >= 4294967290) : (hi$7 > (-1))))) {
      var index = ((1 + lo$5) | 0);
      if ((index > 0)) {
        var this$27 = elem;
        var $x_1 = this$27.substring(0, index);
        var this$29 = elem;
        elem = (($x_1 + ".") + this$29.substring(index));
      } else {
        var end = ((-index) | 0);
        var i$1 = 0;
        while ((i$1 < end)) {
          elem = ("0" + elem);
          i$1 = ((1 + i$1) | 0);
        }
        elem = ("0." + elem);
      }
    } else if ((scale !== 0)) {
      var exponentStr = (((hi$7 === 0) ? (lo$5 !== 0) : (hi$7 > 0)) ? ("E+" + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(lo$5, hi$7)) : ("E" + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(lo$5, hi$7)));
      if ((((18 - currentChar) | 0) > 1)) {
        var this$35 = elem;
        var $x_2 = this$35.substring(0, 1);
        var this$37 = elem;
        elem = ((($x_2 + ".") + this$37.substring(1)) + exponentStr);
      } else {
        elem = (elem + exponentStr);
      }
    }
    return (negNumber ? ("-" + elem) : elem);
  }
});
var $d_Ljava_math_Conversion$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_math_Conversion$, "java.math.Conversion$", ({
  kB: 1
}));
export { $d_Ljava_math_Conversion$ as $d_Ljava_math_Conversion$ };
var $n_Ljava_math_Conversion$;
function $m_Ljava_math_Conversion$() {
  if ((!$n_Ljava_math_Conversion$)) {
    $n_Ljava_math_Conversion$ = new $c_Ljava_math_Conversion$();
  }
  return $n_Ljava_math_Conversion$;
}
export { $m_Ljava_math_Conversion$ as $m_Ljava_math_Conversion$ };
